import {
  Select,
  type SelectOptionItem,
  Typography,
} from '@yandex-delivery/blocks'
import {useController, useFormContext} from '@yandex-delivery/form'
import {get} from '@yandex-delivery/utils'
import React, {useCallback} from 'react'
import {Body} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import {fallbackOption, options} from './consts'

type Props = {
  name: string
  'data-testid'?: string
  onChange?: (value?: string | null) => void
}

const optionsValues = options.map(get('value'))

export function PredefinedParcelSelect({
  name,
  'data-testid': dataTestId,
  onChange,
}: Props) {
  const {control} = useFormContext()
  const {field, fieldState} = useController({control, name})

  const changeHandler = useCallback(
    (value: SelectOptionItem<string> | null) => {
      field.onChange(value?.value)
      onChange?.(value?.value)
    },
    [field, onChange],
  )

  if (!optionsValues.includes(field.value)) {
    onChange?.(fallbackOption.value)
    field.onChange(fallbackOption.value)
  }

  return (
    <Body
      lead={
        <Typography group="tight" mt="m" thickness="medium" variant="body2">
          {i18n('cargo.create.destinations.parcel', 'Что везём')}
        </Typography>
      }
      tail={
        <Select<string>
          data-testid={dataTestId}
          error={fieldState.invalid}
          helperText={fieldState.error?.message}
          onBlur={field.onBlur}
          onChange={changeHandler}
          options={options}
          placeholder={i18n(
            'order-form.parcel-name-select.placeholder',
            'Выберите',
          )}
          value={field.value}
        />
      }
    />
  )
}
